import { render } from "./PagePeriodMgmt.vue?vue&type=template&id=3ea4d760&scoped=true&ts=true"
import script from "./PagePeriodMgmt.vue?vue&type=script&lang=ts"
export * from "./PagePeriodMgmt.vue?vue&type=script&lang=ts"

import "./PagePeriodMgmt.vue?vue&type=style&index=0&id=3ea4d760&scoped=true&lang=css"

import exportComponent from "D:\\project\\CDM_QR-Access-Control-System-3\\DoorWebApp_Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ea4d760"]])

export default __exports__